module.exports = __webpack_public_path__ + "img/2-4.25745a7b.svg";